import {
  GETWALLETOWNERCONFIGURATIONLIST_SUCCESS,
  GETWALLETOWNERCONFIGURATIONLIST_FAILED,
  RESET_GETWALLETOWNERCONFIGURATIONLIST,
  LOADING_GETWALLETOWNERCONFIGURATIONLIST,
  NETWORK_ERROR_GETWALLETOWNERCONFIGURATIONLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWALLETOWNERCONFIGURATIONLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERCONFIGURATIONLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERCONFIGURATIONLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETWALLETOWNERCONFIGURATIONLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETWALLETOWNERCONFIGURATIONLIST:
      return (state = initialState);
    default:
      return state;
  }
};
